import { render, staticRenderFns } from "./MediaPackageForm.vue?vue&type=template&id=80ca1064&"
import script from "./MediaPackageForm.vue?vue&type=script&lang=js&"
export * from "./MediaPackageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports